import { useStore } from "@/store/Store";

export class SatelliteControl {

	_container?: HTMLElement;
	_map: any;

	_unwatch: any;

	store = useStore()


	onAdd(map) {
		this._map = map;
		this._container = document.createElement('div');
		// this._container.textContent = 'Hello, world';
		this.updateClasses()
		const btn = document.createElement("button")
		btn.className = "sat-ctrl"
		btn.addEventListener("click", () => {
			if (this._map.isStyleLoaded()) {
				this.store.satellite = !this.store.satellite;
			}
		})
		// btn.textContent = store.state.satellite ? "Map" : "Sat"
		this._container.appendChild(btn);

		return this._container;
	}

	onRemove() {
		this._container?.parentNode?.removeChild(this._container);
		this._map = undefined;
	}

	updateClasses() {
		if (this._container) {
			const classes = 'maplibregl-ctrl maplibregl-ctrl-group sat-group' + (this.store.satellite ? " sat" : "")
			this._container.className = classes;
		}
	}
}